import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

const WebContext = createContext(null);

export const WebProvider = ({ children }) => {
  const [xp, setXp] = useState(1240);
  const [challengeDone, setChallengeDone] = useState(false);
  const [saved, setSaved] = useState({});
  const [liked, setLiked] = useState({});
  const [chips, setChips] = useState({ learn: 'All', jobs: 'All', clubs: 'My Clubs' });
  const [theme, setTheme] = useState('light');
  const [toast, setToast] = useState('');
  const toastTimer = useRef(null);

  const showToast = useCallback((message) => {
    setToast(message);
    window.clearTimeout(toastTimer.current);
    toastTimer.current = window.setTimeout(() => setToast(''), 1800);
  }, []);

  const value = {
    xp,
    challengeDone,
    saved,
    liked,
    chips,
    theme,
    toast,
    showToast,
    setChip: (group, next) => setChips((prev) => ({ ...prev, [group]: next })),
    toggleTheme: () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark')),
    markSaved: (key, message) => {
      setSaved((prev) => ({ ...prev, [key]: true }));
      if (message) showToast(message);
    },
    toggleLike: (key) => setLiked((prev) => ({ ...prev, [key]: !prev[key] })),
    startChallenge: () => {
      if (challengeDone) return;
      setChallengeDone(true);
      setXp((value) => value + 50);
      showToast('+50 XP earned');
    },
  };

  return <WebContext.Provider value={value}>{children}</WebContext.Provider>;
};

export const useWeb = () => {
  const context = useContext(WebContext);
  if (!context) throw new Error('useWeb must be used inside the web student layout');
  return context;
};
